import { render, staticRenderFns } from "./ViagemTab.vue?vue&type=template&id=850247a2"
import script from "./ViagemTab.vue?vue&type=script&lang=js"
export * from "./ViagemTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports